const nextRoutes = require('next-routes')
const routes = (module.exports = nextRoutes())

routes.add('cart', '/cart')

routes.add('giftsList', '/__gifts/:partition')

routes.add('product', '/:category/:partition/:product')
routes.add('category', '/:category/:partition?')
routes.add('index', '/')